var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8384 24.8384 32 16 32C7.1616 32 0 24.8384 0 16C0 7.1616 7.1616 0 16 0C24.8384 0 32 7.168 32 16Z",
    fill: "#6A67F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6654 18.6667L15.9987 16L13.332 18.6667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V22",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5943 20.2593C22.2445 19.9049 22.7582 19.3439 23.0542 18.6651C23.3502 17.9862 23.4118 17.2282 23.2291 16.5105C23.0464 15.7928 22.6299 15.1563 22.0454 14.7016C21.4609 14.2469 20.7415 13.9998 20.0009 13.9993H19.1609C18.9592 13.2188 18.5831 12.4942 18.0609 11.88C17.5388 11.2658 16.8842 10.7779 16.1463 10.4531C15.4085 10.1282 14.6066 9.97491 13.801 10.0046C12.9954 10.0343 12.207 10.2462 11.4951 10.6244C10.7831 11.0027 10.1662 11.5374 9.6907 12.1884C9.21517 12.8394 8.89341 13.5897 8.7496 14.3829C8.6058 15.1762 8.64369 15.9917 8.86043 16.7682C9.07716 17.5447 9.46711 18.2619 10.001 18.866",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6654 18.6667L15.9987 16L13.332 18.6667",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.fc979303be15419904f736239b0570fa.svg";
export { ForwardRef as ReactComponent };